import { FC } from 'react';
import { Button } from '@carbon/react';
import { PageHeader } from 'components/page-header';
import { format0 } from 'utils/number';
import styles from '../page.module.scss';

// The run page header: the title, a link back to the hub, and the Execute
// action labelled with how many groups it would act on.
export const AddressRunHeader: FC<{
  runId: number;
  executableCount: number;
  executeDisabled: boolean;
  onAllRuns: () => void;
  onExecute: () => void;
}> = ({ runId, executableCount, executeDisabled, onAllRuns, onExecute }) => (
  <PageHeader
    breadcrumbs={[]}
    title={`Dedupe Run #${runId}`}
    actions={
      <div className={styles.headerActions}>
        <Button kind="ghost" size="sm" onClick={onAllRuns}>
          All runs
        </Button>
        <Button
          kind="primary"
          size="sm"
          onClick={onExecute}
          disabled={executeDisabled}
        >
          Execute Deduplications ({format0(executableCount)})
        </Button>
      </div>
    }
  />
);
